// extracted by mini-css-extract-plugin
export default {"tooltip":"VP-z","arrow":"WP-z"};